import src from "IMAGE";
export default { src, width: 192, height: 128, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/webp;base64,UklGRlgAAABXRUJQVlA4TEsAAAAvBwABAM1VICICHgjaCQQAAIAXcANA4QAAgAIAAAAAAAAAAAAAAAAAAAAAAABAAAAKBiKCAM0HAAARkZN4JLSGb3S9H/TZbyjXVggA"};
